export const lang = {
  homepage: 'Homepage',
  download: "Download",
  downloadMsg: "Suggest you use Google browser, Google browser can use the camera",
  loginPage1: "Teacher's Center",
  loginPage2: "Do not have an account?",
  loginPage3: "Sign Up",
  loginPage4: "now",
  loginPage5: "Forgot password?",
  loginPage6: "Reset Password",
  loginPage7: "Login",
  loginPage8: "email",
  loginPage9: "password",
  loginPage10: "Please enter a valid email address",
  loginPage11: "6 to 14 characters in length",
  loginPage12: "Send code",
  loginPage13: "Verification code",
  loginPage14: "Confirm Password",
  loginPage15: "Submit",
  loginPage16: "Already have an account?",
  loginPage17: "Please enter a valid verification code",
  loginPage18: "Please enter the password",
  loginPage19: "Please enter the password again",
  loginPage20: "Input password Inconsistent",
  loginPage21: "Please check the mailbox",
  loginPage22: "Modified successfully",
  loginPage23: "Request failed Please try again later",
  loginPage24: "Account or password is incorrect",
  loginPage25: "Registration successful",
  loginPage26: "Please fill in the verification code",
  loginPage27: "Get code",
  loginPage28: "Get verification code",
  loginPage29: "Dear Teacher:",
  loginPage30: "We've sent you an email.Please enter the code in the email to activate your account.",
  loginPage31: "If you do not receive the email,please check your spam.",
  steps1: "Sign Up",
  steps2: "Basic Info",
  steps3: "In Review",
  steps4: "Success",
  steps5: "Error",
  userPage1: "Name",
  userPage2: "Birthday",
  userPage3: "Select Date",
  userPage4: "Gender",
  userPage5: "Male",
  userPage6: "Female",
  userPage7: "Phone",
  userPage8: "choose a phone",
  userPage9: "Skype",
  userPage10: "Country",
  userPage11: "Education",
  userPage12: "choose a type",
  userPage13: "choose a type",
  userPage14: "Teaching Experience",
  userPage15: "Organization Name",
  userPage16: "Job Title",
  userPage17: "Working Hours",
  userPage18: "Hours Per Week",
  userPage19: "Self Introduction",
  userPage20: "Please Fill All The Blacks",
  userPage21: "Start Time",
  userPage22: "End Time",
  userPage23: "Please enter name",
  userPage24: "Please choose birthday",
  userPage25: "Please choose gender",
  userPage26: "Please choose phone",
  userPage27: "Please enter skype",
  userPage28: "Please choose nationality",
  userPage29: "Please choose certificate",
  userPage30: "Please fill in blank with 4 to 500 characters",
  userPage31: "Please enter phone",
  userPage32: "Hours per week is a numeric value",
  userPage34: "Please enter a numeric value",
  userPage35: "Please enter your introduction",
  userPage36: "High School",
  userPage37: "Associate's",
  userPage38: "Bachelor's",
  userPage39: "Master's",
  userPage40: "Doctorate",
  userPage41: "None of the above",
  userPage42: "Please wait for a call from our officials and follow our interview and mock class test!",
  userPage43: "In Review",
  userPage44: "Congratulations, you have passed our review. Welcome to the BingoTalk family. ",
  userPage45: "Go To Teacher's Center",
  userPage46: "You did not pass our review. Please resubmit the audit material. ",
  userPage47: "Go To Teacher's auth",
  userPage48: "Activation successful",
  userPage49: "5 seconds to jump to the teacher's center",
  userPage50: "Activation Failure",
  userPage51: "Please activate your mailbox again",
  userPage52: "Send Activate Email",
  userPage53: "Send success",
  userPage54: "Missing mail address",
  userPage55: "Name",
  userPage56: "Age",
  userPage57: "Nationality",
  userPage58: "Self Intro",
  userPage59: "change Password",
  userPage60: "Stop or Resume Cooperation",
  userPage61: "change",
  userPage62: "edit",
  userPage63: "upload",
  userPage64: "cancel",
  userPage65: "Upload Avatar",
  userPage66: "Avatar",
  userPage67: "Self Intro Video",
  userPage68: "Play",
  userPage69: "Basic Info",
  userPage70: "Please email the reasons to",
  userPage71: "Copy",
  userPage72: "I know",
  userPage73: "Change Password",
  userPage74: "Old Password",
  userPage75: "New Password",
  userPage76: "Confirm Password",
  userPage77: "upload video success",
  userPage78: "Please upload video file with MP4 video format",
  userPage79: "Upload file size cannot exceed 100MB",
  userPage80: "Please upload a JPG or PNG image within 5M",
  userPage81: "upload avatar success",
  userPage82: "Please enter the oldPassword",
  userPage83: "newPassword : 6 to 14 characters in length",
  userPage84: "Please enter the newPassword",
  userPage85: "checkPass : 6 to 14 characters in length",
  userPage86: "The new password should be different from the old password",
  userPage87: "Please fill in your name",
  userPage88: "Password modification succeeded",
  userPage89: "copy success",
  userPage90: "copy failed",
  userPage91: "close",
  userPage92: "Edit Schedule",
  userPage93: "Basic Info",
  userPage94: "Just Login",
  demoPage1: "First of all，Please choose your convenient time for class",
  demoPage2: "Next",
  demoPage3: "Add",
  demoPage4: "Now，you can add a convenient time for class.",
  demoPage5: "we will automatically save into a draft",
  demoPage6: "Save Schedule",
  demoPage7: "After adding the time, click the button to save schedule",
  demoPage8: "Ok",
  demoPage9: "Skip",
  demoPage10: "You can switch language here",
  demoPage11: "Make an appointment according to your own plan",
  demoPage12: "You can find your courses within 24h here",
  demoPage13: "CN",
  demoPage14: "Done",
  demoPage15: "Your Name",
  headerPage1: "Logout",
  silderPage1: "Home",
  silderPage2: "Booking",
  silderPage3: "Classroom",
  silderPage4: "Account",
  silderPage5: "Payment",
  silderPage6: "score",
  silderPage7: "Guide",
  silderPage8: 'Download',
  homePage1: "Coming Soon",
  homePage2: "No course to take",
  homePage3: "1V1 Class",
  homePage4: "Open Class",
  homePage5: "1Vn Class",
  homePage6: "Booking（1V1&1Vn）",
  homePage7: "Booked（1v1）",
  homePage8: "Enter",
  homePage9: "Currect Week Syllabus",
  homePage10: "Choose Time",
  homePage11: "Local Time",
  homePage12: "Beijing Time",
  homePage13: "Booked",
  homePage14: "Chlid",
  homePage15: "Age",
  homePage16: "Level",
  homePage17: "Lesson",
  homePage18: "Time",
  homePage19: "Details",
  homePage20: "Monday",
  homePage21: "Tuesday",
  homePage22: "Wednesday",
  homePage23: "Thursday",
  homePage24: "Friday",
  homePage25: "Saturday",
  homePage26: "Sunday",
  homePage27: "No Appointment",
  homePage28: "Finished",
  homePage29: "UnderReview",
  homePage30: "Absenteeism Teacher",
  homePage31: "Absenteeism Student",
  homePage32: "Unqualified",
  homePage33: "Prepare course",
  homePage34: "Auditions",
  homePage35: "Booked（1Vn）",
  bookPage1: "Syllabus",
  bookPage2: "Next Week",
  bookPage3: "Currect Week",
  bookPage4: "Last Week",
  bookPage5: "Save Schedule",
  bookPage6: "Time Zone",
  bookPage7: "Choose",
  bookPage8: "添加临时课程成功",
  bookPage9: "点击保存课程表按钮来进行保存",
  bookPage10: "取消临时课程成功",
  bookPage11: "保存课程表成功",
  bookPage12: "need booking",
  bookPage13: "there are {num} recommended times open for booking",
  bookPage14: "open for booking",
  classRoom1: "Back",
  classRoom2: "Page Up",
  classRoom3: "Page Down",
  classRoom4: "page",
  classRoom5: "no data",
  classRoom6: "Note",
  classRoom7: "Rendering cancelled, page 1",
  classRoom8: "Failed to load PDF, Reload.",
  classRoom9: "Remark successful",
  classRoom10: "Course type",
  classRoom11: "Search",
  classRoom12: "Only shows completed courses, scheduled courses within 24 hours",
  classRoom13: "Coming Soon",
  classRoom14: "Opening",
  classRoom15: "Completed",
  classRoom16: "UnderReview",
  classRoom17: "TeachersAbsenteeism",
  classRoom18: "StudentsAbsenteeism",
  classRoom19: "Unqualified",
  classRoom20: "Play Back",
  classRoom21: "Preparation",
  classRoom22: "Student info",
  classRoom23: "no search data",
  classRoom24: "All",
  classRoom25: "Comment",
  classRoom26: "Recent reviews",
  classRoom27: "no search reviews",
  classRoom28: "bad",
  classRoom29: "not bad",
  classRoom30: "good",
  classRoom31: "great",
  classRoom32: "perfect",
  classRoom33: "Student Score",
  classRoom34: "Platform Score",
  classRoom35: "Please enter the comments",
  classRoom36: "Score success",
  classRoom37: "Salary: ",
  classRoom38: "System Note",
  homePage: 'Home Page',
  openingTime: 'Opening Time',
  pendingCourse: 'Pending Courses： ',
  openClass: 'Open',
  miniClass: '1vN',
  recentCourse: 'Recent Course',
  pendingCourses: 'Pending',
  takenCourse: 'Taken',
  noPendingCourses1: 'No pending courses',
  noPendingCourses2: 'Please open more hours for students to see you',
  classInfo: 'Class Info',
  payment: 'Payment: ',
  time: 'Time: ',
  course: 'Course: ',
  unit: 'Unit: ',
  notes: 'Notes: ',
  nothingYet: 'Nothing yet.',
  lessonPreview: 'Lesson Preview',
  localTime: 'Local Time: ',
  BeijingTime: 'Beijing Time: ',
  morning: 'Morning',
  afternoon: 'Afternoon',
  night: 'Night',
  allOpen: 'Open All',
  cancelAll: 'Cancel All',
  personalInfo: 'Personal Info.',
  age: 'Age: ',
  nationality: 'Nationality: ',
  selfIintroduction: 'Self-introduction',
  selfIntroductionVideo: 'Self-introduction video',
  change: 'Change',
  cooperationTip1: 'To stop or resume cooperation, please send an application to the email address: ',
  cooperationTip2: 't.report@bingotalk.cn',
  unbindling: 'Unbind account',
  unbindlingTip: 'Are you sure you want to unbind?',
  cancel: 'Cancel',
  unbind: 'Unbind',
  ordered1v1: '1v1 Booked',
  orderedOpen: 'Open Booked',
  ordered1vN: '1vN Booked',
  classeBegin: 'Booked',
  addTime: "添加课程成功",
  cancelTime: "取消课程成功",
  classURL: "Class Link: ",
  copyLink: "Copy",
  copySuccess: "Copy successfully and open in your PC browser!",
  courseTitle: "Course",
  homeTitle: "Home",
  meTitle: "About Me",
  bookingTitle: "Booking",
  loadMore: "Scroll up to load more",
  noMore: "No more data",
  wrongTimezone: "Wrong TimeZone?",
  timezoneTip: "Correct your time zone by setting your available time on PC web client(Browse).",
  selectTZ: "Please select timezone",
  TZ: "timezone",
  confirm: "Confirm",
  select: "select",
  tzNullTip: "Please select timezone",
  qrTipLine1: "Scan the QR code with WeChat, and it is more convenient",
  qrTipLine2: "to set your available time through our official account.",
  browserTipTitle: "Tips",
  browserTip: "The system detects that you are not using Google Chrome to access our website. Using other browsers may cause a poor experience, so we strongly recommend that you use Google Chrome for a better experience.",
  downloadChrome: "Download Chrome",
  ChromeURL: "https://www.google.cn/intl/en_us/chrome/",
  backupBtn: "Alternative link (Chinese teacher only)",
  recommendTip: "Need Booking"
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js